import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
// require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';
import 'slick-carousel/slick/slick';
import 'masonry-layout/dist/masonry.pkgd';
import 'imagesloaded/imagesloaded.pkgd';
import 'hc-sticky/dist/hc-sticky';
import 'lazysizes';
import slidebars from "exports-loader?slidebars!Slidebars/dist/slidebars.js";
import './modules/disqus';
import './vendor/jquery.requestAnimationFrame';
import './vendor/ilightbox.packed.min.js';
import './vendor/jquery.mousewheel'; 
 

$(document).foundation();

var direction = $('html').css("direction").toLowerCase() === 'rtl' ? 'right' : 'left';
var direction_boolean = $('html').css("direction").toLowerCase() === 'rtl';

$("#return-to-top, .scroll-top").click(function(){$("body,html").animate({scrollTop:0},500)})

$('.searchbox-toggle').on('click', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    $(this).toggleClass('focused');
    $(this).find('i').toggleClass('icon-magnifier icon-circle');
    if ($(this).next().hasClass("open")) {
        $(this).next().removeClass('open')
    } else {
        $('.search-form').removeClass('open');
        $(this).next().addClass('open');
    }
});

$('.dropdown-toggle').on('click', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    if ($(this).next().hasClass("open")) {
        $(this).next().removeClass('open')
    } else {
        $('.dropdown-menu').removeClass('open');
        $(this).next().addClass('open')
    }
});

$(document).click(function (e) {
    e.stopPropagation();
    var container = $('.main-header-inner');
    //check if the clicked area is dropDown or not
    if (container.has(e.target).length === 0) {
        $('.dropdown-menu, .search-form').removeClass('open');
        $('.searchbox-toggle').removeClass('focused');
        $(".searchbox-toggle").find('i').removeClass('icon-circle').addClass("icon-magnifier");
    }
});

// Initialize Slidebars
var controller = new slidebars();
controller.init();

$(document).on('click', '.toggle-nav-panel', function (event) {
    // Stop default action and bubbling
    event.stopPropagation();
    event.preventDefault();

    // $('.toggle-nav-panel').find('i').toggleClass('icon-menu icon-close');
    $('.toggle-nav-panel').toggleClass('is-active');
    //console.log("panel");
    // Toggle the Slidebar with id 'id-4'
    controller.toggle('nav-panel');
});

// Add close class to canvas container when Slidebar is opening
$(controller.events).on('opening', function (event) {
    $('[canvas="container"]').addClass('sb-opening');
});

// Add close class to canvas container when Slidebar is opening
$(controller.events).on('opened', function (event) {
    $('[canvas="container"]').addClass('sb-opened');
});

// Remove close class from canvas container when Slidebar is closing
$(controller.events).on('closing', function (event) {
    $('[canvas="container"]').removeClass('sb-opening');
});

// Remove close class from canvas container when Slidebar is closing
$(controller.events).on('closed', function (event) {
    $('[canvas="container"]').removeClass('sb-opened');
});

// Close any
$(document).on('click', '#sb-blocker, .close-panel span', function (event) { //.sb-opening
    if (controller.getActiveSlidebar()) {
        event.preventDefault();
        event.stopPropagation();
        controller.close();
    }
    $('.toggle-nav-panel').removeClass('is-active');
    // $('.toggle-nav-panel').find('i').removeClass('icon-close');
    // $('.toggle-nav-panel').find('i').addClass('icon-menu');
});

// STICKY 

$(".header-sticky").hcSticky({
    stickTo: 'body'
  });
  

if ($('.sticky-area').length > 0) { 
    var stickySectionTitles = document.getElementsByClassName('sticky-area');
 
    for (var i = 0; i < stickySectionTitles.length; i++) {
        new hcSticky(stickySectionTitles[i], {
            stickTo: stickySectionTitles[i].parentNode,
            top: 80,
            // responsive: {
            //     800: {
            //         disable: true
            //     }
            // }
        });
   
    }
} 
if($('.video-hiatv').length > 0) {
    var videoURL = "";
    var count_video = '1'
    var tid = $('.video-hiatv .video-container').data('video-tid');

    if ($('.video-hiatv .video-container').data('count-video')) {
     var count_video = $('.video-hiatv .video-container').data('count-video');
    }
    console.log(count_video);
    
    if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
        videoURL = "assets/json/" + tid + ".json";
    } else if (tid == 0) {
      videoURL = "https://tv.hiamag.com/widget?"+ Math.floor(Math.random() * 90000);
    } else {
      videoURL = "https://tv.hiamag.com/widget/" + tid + "?"+ Math.floor(Math.random() * 90000);
    }

    $.ajax({
        url: videoURL,
        dataType: "json",
        cache: false
    }).done(function (result) {
        console.log('result: ', result)
        var videoList = result.nodes ? result.nodes : [];
        // console.log('videoList: ', videoList)
        var videoItem = ""
        if (videoList.length > 0) {
            for (var i = 0; i <= videoList.length; i++) {
                // console.log('videoList[i].node: ', videoList[i].node)
                videoItem = '<div class="cell"><article class="article-item"><div class="article-item-head"><div class="ratio-container"><a href="https://tv.hiamag.com/node/' + videoList[i].node.Nid + '"></a><img class="lazyload" data-sizes="auto" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-src="' + videoList[i].node.Main_image + '"><span class="play-icon"><img src="/themes/custom/hiamag/assets/img/icons/play.png" alt=""></span></div></div><div class="article-item-title"><h3><a href="https://tv.hiamag.com/node/' + videoList[i].node.Nid + '">' + videoList[i].node.title + '</a></h3></div></article></div>';
                $('.video-container').append(videoItem);
                if(i == count_video) {
                    return false; // breaks
                }
            }
        }
    });
}
// masonry grid
  
var $grid = $('#masonry-grid').masonry({
    itemSelector: '.grid-item',
    columnWidth: '.grid-sizer',
    percentPosition: true,
    transitionDuration: 2,   
  });

  $grid.imagesLoaded().progress( function() {
    $grid.masonry();
  });

  var $grid2 = $('#masonry-grid2').masonry({
    itemSelector: '.grid-item',
    columnWidth: '.grid-sizer',
    percentPosition: true,
    transitionDuration: 2,   
  });

  $grid2.imagesLoaded().progress( function() {
    $grid2.masonry();
  });

  var $grid3 = $('.masonryGridJs').masonry({
    itemSelector: '.grid-item',
    columnWidth: '.grid-sizer',
    percentPosition: false,
    transitionDuration: 2,   
  });

  $grid3.imagesLoaded().progress( function() {
    $grid3.masonry();
  });
 
// bind change event to select
  $('#dynamic_select').on('change', function () {
      var url = $(this).val(); // get selected value
      var url =  window.location.origin+'/magazine'+url;
      if (url) { // require a URL
          window.location = url; // redirect
      }
      return false;
  });  
  // scroll to top 

$(window).on("scroll", function(){
    if ($(this).scrollTop() > 50 ) {
      $('.scrollToTop-js').fadeIn();
    } else {
        $('.scrollToTop-js').stop(true, true).fadeOut();
    }
  });
  
  $(".scrollToTop-js").on("click", function(){
    $('html,body').animate({
      scrollTop: $(".atthetop").offset().top
    }, 500);
    return false; 
  }) 
  
// PARALLAX 

// if ($("#parallax").length > 0){
//     const parallaxImg = document.getElementById("parallaxImg"),
//         parallaxHeight = $("#parallax").height();  
 
//   window.addEventListener( "scroll", function  () {
    
//     let offset = Math.round(window.scrollY - $("#parallax").offset().top); 
//     //console.log(offset, 'window.pageYOffset');
    
//     if (offset < parallaxHeight){
//       console.log("lessthan");
//       if(offset <  0 ){
//         offset = 0;  
//         parallaxImg
//         .style
//         .transform = `translate3d(0px, ${offset*0.5}px,  0px) scale(1.1)`; 
//       }else{
//         parallaxImg
//         .style 
//         .transform = `translate3d(0px, ${offset*0.2}px, 0px) scale(1.1)`;  
//       }
//     }else{
//       console.log("morethan");
//     } 
//   })
  
// }
 
const parallax = document.getElementById("parallax"),
parallaxHeight = $("#parallax").height(); 
//const header = document.getElementById("parallaxContent");
//header.style.transform = `translateY(${0}px)`; 
var indexOf = [].indexOf;

if ($("#parallax").length > 0){
  window.addEventListener( "scroll", function  () {
  
    let offset = Math.round(window.scrollY - $("#parallax").offset().top + 30);
    
    if (offset < parallaxHeight){ 
      if(offset <  0 ){
        offset = 0;  
        // header
        // .style
        // .transform = `translateY(${offset*0.5}px)`;
        // header
        // .style
        // .opacity = `${1 / offset*50}`;
        parallax.style.backgroundPositionY = offset * 0.7 + 'px';
      }else{
        // header
        // .style
        // .transform = `translateY(${offset*0.5}px)`;
        // header
        // .style
        // .opacity = `${1 / offset*50}`;
        parallax.style.backgroundPositionY = offset * 0.7 + 'px';
      }
  
    } 
  })
}

// moving left right
// if (indexOf.call(window, 'ontouchstart') >= 0 === false) {
//   $("body").mousemove(function (e) {
//     var moveX, moveY;
//     moveX = e.pageX * -1 / 25 + 'px';
//     moveY = e.pageY * -1 / 25 + 'px';
//     return $('#parallax').css('background-position-x', 'calc(50% + ' + moveX + ')');
//   });
// }

// media slider

if ($(".media-slider").length > 0){
  var mediaSlider = $('.media-slider');
    var mediaImgHeight;
    var sliderContentHeight;
    mediaSlider.slick({
        lazyLoad: 'progressive',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true, 
        fade: true,
        rtl: true,
        adaptiveHeight: true,
        prevArrow: $('.slick-prev'),
        nextArrow: $('.slick-next'),
        //mobileFirst: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    swipe: false
                }
            }
        ]
    });

    if (mediaSlider.hasClass("autoplay-slick")){ 
      $('.media-slider').slick('slickPlay')
    }
    

    function fixCtrlPosition() {
        // mediaImgHeight = $('.media-slider .slick-current img').height();
        // console.log(mediaImgHeight);
        // $('.media-slider .slick-prev, .media-slider .slick-next').css({'top': (mediaImgHeight - 50) / 2});

        sliderContentHeight = mediaSlider.find('.slick-current .slider-item-caption').outerHeight() || 0;
        // console.log(sliderContentHeight);
        mediaSlider.find('.slick-prev, .slick-next').css({'margin-top': -(sliderContentHeight + 50) / 2});

    }

    mediaSlider.on('setPosition', function (slick) {
        fixCtrlPosition();
    });
    mediaSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        if (window.LimelightPlayer) {
            LimelightPlayer.doPause();
        }
        if ($(slick.$slides[currentSlide]).find('.yt_player_iframe').length > 0) {
            $(slick.$slides[currentSlide]).find('.yt_player_iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        }
    });
    mediaSlider.on('afterChange', function (slick, currentSlide) {
        //mediaImgHeight = $(slick.$slides.get(slick.currentSlide)).find('.slider-item-img').height();
        //$('.media-slider .slick-prev, .media-slider .slick-next').css('top',(mediaImgHeight-54)/2); 
       // call_google_analytics();
    });

    //on arrow click 
    $(".slick-arrow", mediaSlider).on("click", function(){
      call_google_analytics(); 
    });
}

if ($("#btn-advance").length > 0){
  $("#btn-advance").on("click", function (){ 
    $(".advance-filter").toggle("fast");
    $(this).toggleClass("collapsed"); 
    //$(this).text("collapsed"); 

    if ($(this).hasClass("collapsed")) {
      $(this).find("span").text("إلغاء");
    } else {
      $(this).find("span").text("بحث متقدم");
    }
   
  })
}

if ($(".slick-mobile_js").length > 0){
  //if (Foundation.MediaQuery.current == "small"){ 
    $('.slick-mobile_js').slick({  
      mobileFirst:true, 
      centerMode: true,
      centerPadding: '60px',
      slidesToShow: 2,
      rtl: true,
      arrows: false,
      responsive: [
            {
                breakpoint: 2000,
                settings: "unslick"
            },
            {
                breakpoint: 1600,
                settings: "unslick"
            },
            {
                breakpoint: 1024,
                settings: "unslick"
            },
            {
                breakpoint: 600,
                settings: "unslick"
            },
            {
                breakpoint: 480,
                settings: { 
                  slidesToShow: 2
                }
            }
          ]

    });
  //}
}

if ($(".menu-carousel_js").length > 0){ 
    $('.menu-carousel_js').slick({ 
       centerMode: true,
       centerPadding: '12rem',
      slidesToShow: 4,
      rtl: true,
      arrows: false,
      focusOnSelect: true, 
      responsive: [
        {
          breakpoint: 1170,
          settings: { 
          centerPadding: '80px',
          slidesToShow: 3,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2 
          }
        },
        {
          breakpoint: 560,
          settings: {
            slidesToShow: 2,
            centerPadding: '80px',
          }
        },
        {
          breakpoint: 480,
          settings: { 
            slidesToShow: 2,
            centerPadding: '60px',
          }
        }
       
      ]
    });
     
 

    $( window ).on('resize', function() {
      slickTargetActive();
    });

    slickTargetActive()

    function slickTargetActive(){ 

      var slickNumber = $('.menu-carousel_js').find('a.active').parents(".slick-slide").data("slick-index"); 
      $('.menu-carousel_js').slick('slickGoTo', slickNumber + 1 );
      $('.menu-carousel_js').find('a.active').parents(".slick-slide").addClass("slick-current slick-center"); 
     
    }
     
}


// ilightbox
if ($(".ilightbox").length > 0){ 
  var totalLightBox = $(".ilightbox").length;

  $('.ilightbox').iLightBox({
    skin: 'metro-black',  
    maxScale: 2,
    thumbnails: { 
      maxWidth: 140,
      maxHeight: 80,
      normalOpacity: .8,
      activeOpacity: 1
    },
    styles: {
      pageOffsetY: 50,
      //pageOffsetX: -100,  
    },
    effects: {
        switchSpeed: 700
    },
    controls: {
        thumbnail: 1,
        arrows: true,
        slideshow: false,
        fullscreen: false
    }, 

    slideshow: {
      pauseTime: 3000
    }, 
    
    caption:{
      start: false,
      show: 'click',
      hide: 'click' 
    },
 
    overlay: {
      blur: true,
      opacity: .85
    },
    
    text: {
      close: "Press Esc to close",
      enterFullscreen: "Enter Fullscreen (Shift+Enter)",
      exitFullscreen: "Exit Fullscreen (Shift+Enter)",
      slideShow: "Slideshow",
      next: "Next",
      previous: "Previous"
    },
    errors: {
      loadImage: "An error occurred when trying to load photo.",
      loadContents: "An error occurred when trying to load contents.",
      missingPlugin: "The content your are attempting to view requires the <a href='{pluginspage}' target='_blank'>{type} plugin<\/a>."
    },
    
    callback: {
      onOpen: function(){
        console.log( 'on OPEN');  
        $( ".ilightbox-button").wrapAll('<div class="ilightbox-arrows"></div>');
        $( ".ilightbox-button.ilightbox-next-button" ).after('<div class="ilightbox-counter"><span class="img-page"></span><span>/</span>'+ totalLightBox +'</div>'); 
      }, 
      
      onAfterChange: function(api){
        console.log("on after change");
        var activeLightbox = $(".ilightbox-active").index() + 1;
        // console.log( activeLightbox, 'activeLightbox');
        $( ".ilightbox-counter .img-page" ).text(activeLightbox); 
      }, 
      
      onShow: function(api, position){
      //$(api.element).css({ 'background': 'red' });
      var cItem = api.currentItem + 1;  
          
        //console.log( api, 'api');
        console.log( cItem, 'currentItem'); 
        $( ".ilightbox-counter .img-page" ).text(cItem); 
      
      }, 

      onHide: function(){
        $( ".ilightbox-counter" ).remove(); 
      }
  
    } 
    
  });

}
// POPUP GALLERY


//$('#popup-gallery').on('click', function() {
  //$('#popup-image-gallery').foundation('open');
  
  $('.popup-slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    rtl: true,
    asNavFor: '.popup-slider-nav',
    prevArrow: $(".prev-arrow"),
    nextArrow: $(".next-arrow"),
    adaptiveHeight: true,
  });
  $('.popup-slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 5, 
    vertical: true, 
    verticalSwiping: true, 
    asNavFor: '.popup-slider-for',
    dots: false,
    arrows: false,  
  });
//});
// Slick.js: Get current and total slides (ie. 3/5)
var $status = $('.pagingInfo');
var $slickElement = $('.popup-slider-for');

// $slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
//   //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
//   var i = (currentSlide ? currentSlide : 0) + 1;
//   $status.text(i + '/' + slick.slideCount);
// });

// Slick slider sync situation
// var slides = $(".popup-slider-for .slick-track > .slick-slide").length;
// $('.popup-slider-for').on('afterChange', function(event, slick, currentSlide, nextSlide) {
//   var inFocus = $('.popup-slider-for .slick-current').attr('data-slick-index');
//   $('.popup-slider-nav .slick-current').removeClass('slick-current');
//   $('.popup-slider-nav .slick-slide[data-slick-index="' + inFocus + '"]').trigger('click');
// });

// END POPUP GALLERY



$(document).ready(function () {
 
  // LEADERBOARD SHOW ON SCROLL ONCE
  if($("#leaderboard").length > 0) {  
    var lastScrollTop = 0;
    $(window).on('scroll',function(event){
       var st = $(this).scrollTop();
       if (st > lastScrollTop){
        setTimeout(function() {
          $(".sticky #leaderboard").hide(); //hide leaderboard after 7 seconds
          $(".sticky #leaderboard").addClass('loaded');
        }, 7000);
        if($("#leaderboard").hasClass('loaded')){
          $("#leaderboard").hide();
        }
       } else {
        
       }
       lastScrollTop = st;
      // console.log(st);
       if (st == 0 ){
  
          $("#leaderboard").show(); 
      }
    });
      
  }

  // ARTICLE WRAP VIDEO IFRAME
  var target = $('.entry-content').find('iframe').not('[src*="polldaddy.com"]').not('.instagram-media').not('[src*="docs.google.com"]').not('[src*="hiamag.com"]').not('[src*="cdn.knightlab.com"]');
    target.wrap("<p class='responsive-embed widescreen'></p>");

});
 

function call_google_analytics() {
  var trackURL = jQuery(location).attr("pathname");
  if (trackURL != 'undefined') {

      try {
          trackClickView(trackURL);
      } catch (e) {
          console.log("failed to send a ping to GA");
      }

      try {
          refreshEM(trackURL);
      } catch (e) {
          console.log("failed to ping EM");
      }

  }
};
